import { useChartLayoutObserver } from "@result/rui/hooks";
import ReactECharts from "echarts-for-react";
import { useMemo, useRef } from "react";

import { BreedingValuesChartOptions } from "#/pages/breeding-values/BreedingValuesPage.jsx";

const BreedingValuesBarChart = ({ data, title, labelX, labelY }) => {
  const { A, B } = BreedingValuesChartOptions.groups;

  const chartRef = useRef();
  useChartLayoutObserver(chartRef.current);

  const options = useMemo(() => {
    return {
      title: {
        text: title,
        left: "left",
        top: 0,
        textStyle: {
          color: BreedingValuesChartOptions.titleColor,
        },
      },
      grid: {
        top: 60,
        bottom: 80,
        left: labelY == null ? 0 : 40,
        right: 5,
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        position: "inside",
        axisPointer: {
          type: "line",
          label: {
            show: true,
            color: "#FFFFFF",
            backgroundColor: "#17A1FA",
          },
        },
      },
      legend: {
        data: [A.key, B.key],
        selected: {
          [A.key]: true,
          [B.key]: true,
        },
        bottom: 0,
      },
      xAxis: {
        type: "category",
        name: labelX,
        nameLocation: "middle",
        nameGap: 20,
        boundaryGap: true,
        data: data.x,
      },
      yAxis: {
        type: "value",
        name: labelY,
        nameLocation: "middle",
        nameRotate: 90,
        nameGap: 40,
      },
      series: [
        {
          name: A.key,
          type: "bar",
          data: data.y.A,
          itemStyle: {
            color: A.color,
            borderColor: "#FFFFFFCC",
            borderWidth: 0,
          },
          label: {
            show: true,
            position: "top",
            rotate: 90,
            distance: 20,
            fontSize: 14,
            align: "center",
            verticalAlign: "middle",
          },
        },
        {
          name: B.key,
          type: "bar",
          data: data.y.B,
          itemStyle: {
            color: B.color,
            borderColor: "#FFFFFFCC",
            borderWidth: 0,
          },
          label: {
            show: true,
            position: "top",
            rotate: 90,
            distance: 20,
            fontSize: 14,
            align: "center",
            verticalAlign: "middle",
          },
        },
      ],
      dataZoom: BreedingValuesChartOptions.options.dataZoom,
    };
  }, [chartRef.current]);

  return (
    <ReactECharts
      option={options}
      ref={chartRef}
      notMerge={true}
      lazyUpdate={false}
    />
  );
};

export default BreedingValuesBarChart;
